<template>
  <div>
    <button
      class="btn"
      @click="toggleShowCalendarOptions()"
    >
      <icon
        icon-name="calendar"
        view-box="0 0 16 16"
      />
      {{ $t('cac.app.add_to_calendar') }}
    </button>
    <div
      v-if="showCalendarOptions"
      class="row">
      <a
        :href="gCalURL"
        class="btn upcoming-elections-button__calendar-selection col-9"
        target="_blank"
      >
        Google Calendar
      </a>
      <button
        class="btn upcoming-elections-button__calendar-selection col-9"
        @click="downloadICS()"
      >
        iCal
      </button>
    </div>
  </div>
</template>

<script>
import Icon from "StyleguideComponents/Icon.vue";

import { mapGetters } from "vuex";
import STATE from "Constants/campaign/civicactioncenter/state";
import CalendarButton from "Constants/campaign/civicactioncenter/calendarButton";

const calendarDatesContext = `${STATE.SCOPE_CAC}/${STATE.CALENDAR_DATES}`;

export default {
  name: "CalendarButton",
  components: {
    Icon
  },
  props: {
    electionName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showCalendarOptions: false
    };
  },
  computed: {
    ...mapGetters({
      calendarDates: calendarDatesContext
    }),
    gCalURL() {
      return `${CalendarButton.GCAL_BASE_URL}${
        CalendarButton.GCAL_TEXT_PREFIX
      }${this.electionName}${CalendarButton.GCAL_DATES_PREFIX}${
        this.calendarDates.gCal
      }`;
    }
  },
  methods: {
    toggleShowCalendarOptions() {
      this.showCalendarOptions = !this.showCalendarOptions;
    },
    downloadICS() {
      let iCalTemplate = CalendarButton.ICAL_TEMPLATE;

      // For a full-day event, we need the time at 00:00 on the day of and the day after
      const [startDate, endDate] = this.calendarDates.iCal.split("/");

      iCalTemplate = iCalTemplate.replace(
        CalendarButton.ICAL_KEY_UID,
        this.electionName
      );
      iCalTemplate = iCalTemplate.replace(
        CalendarButton.ICAL_KEY_START_DATE,
        startDate
      );
      iCalTemplate = iCalTemplate.replace(
        CalendarButton.ICAL_KEY_END_DATE,
        endDate
      );
      iCalTemplate = iCalTemplate.replace(
        CalendarButton.ICAL_KEY_SUMMARY,
        this.electionName
      );

      // https://stackoverflow.com/questions/3665115/how-to-create-a-file-in-memory-for-user-to-download-but-not-through-server
      const tempButton = document.createElement("a");
      tempButton.setAttribute(
        "href",
        `data:text/plain;charset=utf-8,${encodeURIComponent(iCalTemplate)}`
      );
      tempButton.setAttribute("download", CalendarButton.ICAL_FILENAME);

      tempButton.style.display = "none";
      document.body.appendChild(tempButton);
      tempButton.click();
      document.body.removeChild(tempButton);
    }
  }
};
</script>
